export default '/build/b28f68c1.svg'